import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap'
import Lang from 'Lang/General'

const PromptModal = ({
  showPromptModal,
  onClickYes,
  onClickNo,
  content,
  lang
}) => {
  return (
    <Modal
      isOpen={ showPromptModal }
      size={ 'md' }>
      <ModalHeader>{ Lang[ 'CONFIRMATION_MODAL' ][ lang ] }</ModalHeader>
      <ModalBody>
        { content }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={ onClickYes }>{ Lang[ 'YES' ][ lang ] }</Button>
        <Button 
          color="danger"
          onClick={ onClickNo }>{ Lang[ 'NO' ][ lang ] }</Button>
      </ModalFooter>
    </Modal>
  )
}

export default PromptModal